import {doc} from './docs.js';
import ZMacro from '../custom/ZMacro.js';

doc(
    "macro",
    {
        "name": ""
    },
    "Map several parameters to a macro object to control",
    () => 0,
    {
        inlets: 0
    });

export const macro = (object) => {
    let mac = new ZMacro(object);
    object.needsLoad = true;
    return ([msg]) => {
        // mac.resetValues();
        mac.sendMessage("value changed", mac.value);
    };
};
